// 货拉拉司机端
var HLL_DRIVER_APPIDS = [
    'com.lalamove.huolala.driver',
    'com.huolala.driver',
    'com.huolala.driverinhouse',
];
// 货拉拉用户端
var HLL_USER_APPIDS = [
    'com.lalamove.huolala.client',
    'com.huolala.user',
    'com.huolala.userinhouse',
];
// 货拉拉企业版
var HLL_EUSER_APPIDS = [
    'com.lalamove.huolala.eclient',
    'com.huolala.euser',
    'com.huolala.euserinhouse',
];
// 专送司机APP
var HLL_CDRIVER_APPIDS = [
    'com.lalamove.huolala.cdriver',
    'cn.huolala.cdriver',
];
// 零担专送司机
var HLL_LTL_DRIVER_APPIDS = [
    'com.lalamove.huolala.ltldriver',
    'cn.huolala.ltldriver',
];
// 搬家小哥APP
var HLL_PORTER_APPIDS = ['com.lalamove.huolala.porter', 'com.huolala.porter'];
// 拉丁APP
var HLL_LATIN_APPIDS = ['com.lalamove.huolala.latin', 'cn.huolala.latin'];
// 其他
// 拉拉助手: iOS com.huolala.force 但安卓没有接 HllWebKit
// 小拉司机端
var XL_DRIVER_APPIDS = [
    'com.xiaolachuxing.driver',
    'com.xiaolachuxing.driveri',
    'cn.huolala.kd',
];
// 小拉用户端
var XL_USER_APPIDS = [
    'com.xiaolachuxing.user',
    'com.xiaolachuxing.useri',
    'cn.huolala.kdu',
];
function formatAppId(appId) {
    // 存在 com.huolala.driver.Q8KTGFK8WH 这类非标 appId，需要将多余的一段剔除
    return appId
        ? appId.replace(/((?:com|cn)\.(?:lalamove\.)?(?:huolala|xiaolachuxing)\.\w+)(?:\.\w+)?/, '$1')
        : undefined;
}
function matchByAppId(result) {
    var appId = result.appId;
    if (!appId) {
        return result;
    }
    if (HLL_DRIVER_APPIDS.indexOf(appId) > -1) {
        result.is_hll_driver_app = true;
    }
    else if (HLL_USER_APPIDS.indexOf(appId) > -1) {
        result.is_hll_user_app = true;
    }
    else if (HLL_EUSER_APPIDS.indexOf(appId) > -1) {
        result.is_hll_euser_app = true;
    }
    else if (HLL_CDRIVER_APPIDS.indexOf(appId) > -1) {
        result.is_hll_cdriver_app = true;
    }
    else if (HLL_LTL_DRIVER_APPIDS.indexOf(appId) > -1) {
        result.is_hll_ltl_driver_app = true;
    }
    else if (HLL_PORTER_APPIDS.indexOf(appId) > -1) {
        result.is_hll_porter_app = true;
    }
    else if (HLL_LATIN_APPIDS.indexOf(appId) > -1) {
        result.is_lading_app = true;
    }
    else if (XL_DRIVER_APPIDS.indexOf(appId) > -1) {
        result.is_xl_driver_app = true;
    }
    else if (XL_USER_APPIDS.indexOf(appId) > -1) {
        result.is_xl_user_app = true;
    }
    return result;
}
function matchByAppFlag(result, flag) {
    if (flag === 'HLLPorterApp') {
        result.is_hll_porter_app = true;
    }
    else if (flag === 'lading') {
        result.is_lading_app = true;
    }
    return result;
}
function toRevision(version) {
    var _a = version.split('.'), major = _a[0], minor = _a[1], patch = _a[2];
    return +"".concat(major).concat(minor).concat(+patch < 10 ? '0' + patch : patch);
}
export default {
    parse: function (userAgent) {
        var ua = userAgent || navigator.userAgent;
        var result = {
            system: '',
            systemVersion: '',
        };
        // 解析通用 UA 头部
        // Mozilla/5.0 (Linux; Android 8.1.0; JKM-AL00b Build/HUAWEIJKM-AL00b; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/77.0.3865.120 MQQBrowser/6.2 TBS/045713 Mobile Safari/537.36
        // Mozilla/5.0 (Linux; Android 11; RMX3122 Build/RP1A.200720.011; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/77.0.3865.120 MQQBrowser/6.2 TBS/045735 Mobile Safari/537.36
        // Mozilla/5.0 (iPhone; CPU iPhone OS 15_3_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148
        // Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/98.0.4758.109 Safari/537.36
        // 正则分组格式: (Android|iPhone|iPad|Mac|Windows) (version)
        var uaMatch = ua.match(/(\sAndroid|iPhone\sOS|iPad|Mac|Windows)\D*([\d\._]*)/);
        var platformMap = {
            ' Android': 'android',
            'iPhone OS': 'ios',
            iPad: 'ios',
            Mac: 'mac',
            Macintosh: 'mac',
            Windows: 'windows',
        };
        if (uaMatch) {
            result.system = platformMap[uaMatch[1] || ''] || '';
            result.systemVersion = (uaMatch[2] || '').replace(/_/g, '.');
        }
        // 解析端内 HllWebKit 追加的 UA 部分
        // /huolala(1030,android,huolala,1.0.30,JKM-AL00b,4B358F7CECC60E7B5E8563983A063872,,oQRkKg9n,com.xiaolachuxing.driver)
        // /huolala(1206,android,SZ-CS-A-Y-oppo,1.2.6,RMX3122,00000000-129e-5e8e-0000-00001970b0a5,5CCE0778338481A00724E831F88DC631E45A54601731AD5F6BCC184C444371803976188B667C0A894CE3AA2B4D40B956,Dva5VRj4,com.xiaolachuxing.driver)
        // /huolala(1208,ios,AppStore,1.2.8,iPhone 6s,86B1048C9ED14BA4A73A35E5D53A81DB,,,com.xiaolachuxing.driveri)
        // 正则分组格式: appRevision, system, appRef, appVersion, deviceModel, deviceId, userToken, userFid, appId
        // 个别非标的 UA 中可能缺少 userFid, appId
        var hllMatch = ua.match(/\/huolala\((\d+),(\w+),([^,]*),([\d\.]+),([^,]+(?:,\d)?),([^,]*),([^,]*)(?:,([^,]*),([\w\.]+))?\)/);
        if (hllMatch) {
            result.appRevision = +hllMatch[1];
            result.system = hllMatch[2];
            result.appRef = hllMatch[3];
            result.appVersion = hllMatch[4];
            result.deviceModel = hllMatch[5];
            result.deviceId = hllMatch[6];
            result.appId = formatAppId(hllMatch[9]);
            matchByAppId(result);
            result.isInApp = true;
        }
        // 兜底处理非标的 UA 极端情况
        if (!hllMatch && ua.indexOf('/huolala(') > -1) {
            // 只取 appRevision, system, appRef, appVersion, 最后的 appId
            var nextMatch = ua.match(
            // 注意 appid 要找结尾 ) 前面一小段
            /\/huolala\((\d*),(\w*),([^,]*),([\d\.]*),.*?((?:com|cn)\.(?:[\w\.]+))?\)/);
            if (nextMatch) {
                result.appRevision = +nextMatch[1];
                result.system = nextMatch[2];
                result.appRef = nextMatch[3];
                result.appVersion = nextMatch[4];
                result.appId = formatAppId(nextMatch[5]);
                matchByAppId(result);
                result.isInApp = true;
            }
        }
        else if (!hllMatch && ua.indexOf('HuolalaUapp') > -1) {
            // 货拉拉用户端 有一部分只有 HuolalaUapp 关键字，无 /huolala(...) 片段
            result.isInApp = true;
            result.is_hll_user_app = true;
        }
        // 识别未接入 HllWebKit 的端
        if (!result.isInApp) {
            // 搬家小哥APP  HLLPorterApp/1.7.21
            // 拉丁APP  lading/2.2.41
            var appMatch = ua.match(/\b(HLLPorterApp|lading)\/([\d\.]+)/);
            if (appMatch) {
                var flag = appMatch[1], version = appMatch[2];
                result.appVersion = version;
                result.appRevision = toRevision(version);
                matchByAppFlag(result, flag);
                result.isInApp = true;
            }
        }
        // 补充字段
        var system = result.system;
        if (system === 'android') {
            result.isAndroid = true;
        }
        else if (system === 'ios') {
            result.isIOS = true;
        }
        else {
            result.isPC = true;
        }
        return result;
    },
};
